import { publicGet } from "../clients/createPublicClient";
import { CPCompanyBrandingQueryResult } from "../models/unified";

export default {
  getCompanyBranding: async (tenantCode: string) => {
    const result = await publicGet<CPCompanyBrandingQueryResult>(
      `customerPortal/public/v2/companyBranding/${tenantCode}`,
    );

    return result;
  },
};
